import { FunctionComponent, useEffect, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next'

import { fetch_all, fetch_one } from '../../lib/server_helper';
import { checkAllowed } from '../../lib/permission';

import {
  CircularProgress,
  Snackbar
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { GridColDef } from '@mui/x-data-grid-pro';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';

import { AlertSomethingWentWrong } from '../../components/alerts/SomethingWentWrong';

import {
  DataGrid,
  Page,
  SearchBox,
  StyledButton,
  StyledIconButton,
  Typography
} from '../../components/interface';

import { getCookie, setCookie } from 'react-use-cookie';

import { Segment } from '../../models/Segment';
import { loginAtom } from '../../lib/auth';

type Props = {};

export const AdminSegments: FunctionComponent<Props> = () => {
  // const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  const [login, setLogin] = useAtom(loginAtom);

  // const params = useParams();
  // const projectId: string | undefined = params.project_id;

  const [objects, setObjects] = useState<Segment[]>([]);
  const [objectsCount, setObjectsCount] = useState<number>(0);
  const [loader, setLoader] = useState<boolean>(true);
  const [removeLoader, setRemoveLoader] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("id DESC");
  const [serverErrorSnackOpen, setServerErrorSnackOpen] = useState<boolean>(false);
  const [activeCompany, setActiveCompany] = useState<string>(getCookie('panelmetrics_active_company_id') || '');

  // Settings


  useEffect(() => {
    if (!!activeCompany) onSearch('');
  }, [page, order, activeCompany]);

  const onRemove = (id: number) => {
    // if (checkAllowed(login, null, projectId?.toString() || '0', "ProjectSegments", 'd', true)) {
      setRemoveLoader(true);
      fetch_one<Segment>('/nl/v3/objects/remove', {
        object: 'segment',
        ob: {
          id: id
        }
      }, (obs, complete_data) => {
        onSearch('');
        setRemoveLoader(false);
      }, (z) => {

      }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
    // }
  };

  const onSearch = (s: string) => {
    // if (checkAllowed(login, null, projectId?.toString() || '0', "ProjectSegments", 'r', true)) {
      // console.log(filters);
      setLoader(true);
      fetch_all<Segment>('/nl/v3/objects/fetch_all', {
        object: 'segment',
        fields: ['id', 'created_at', 'updated_at', 'name', 'extra_data', 'project|name', 'user_count', 'autogenerated'],
        per_page: 20,
        page: page,
        order: order,
        filter: {
          search: s,
          advanced: {
            // project_id: projectId,
            fallback: s,
            company_id: activeCompany
          }
        }
      }, (obs, complete_data) => {
        setObjects(obs);

        let count:number = 0;
        if (typeof(complete_data?.data) === 'object' && 'count' in complete_data?.data) count = complete_data?.data?.count;
        setObjectsCount(count);

        setLoader(false);
      }, (z) => {
        setServerErrorSnackOpen(true);
      }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
    // } else {
    //   setLoader(false);
    // }
  };

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 100, sortable: true },
    { field: 'name', headerName: 'Name', width: 250, sortable: true },
    { field: 'project_name', headerName: 'Project', width: 250, sortable: false },
    { field: 'user_count', headerName: 'UserCount', width: 100, sortable: false },
  ];

  return (
    <Page sx={{}} title={t("objects.segments.title")} actions={<>
      {/* {checkAllowed(login, null, projectId?.toString() || '0', "ProjectSegments", 'c', true) && <StyledButton
        label="Create new"
        id='create_new'
        contained
        path={`/segment/${projectId}/new`}
        sx={{marginRight: 3}}
        startIcon={<AddCircleOutlineIcon />}
      />} */}
      {!!activeCompany && <StyledButton
        label="Create new"
        id='create_new'
        contained
        path={`/segment/new`}
        sx={{marginRight: 3}}
        startIcon={<AddCircleOutlineIcon />}
      />}
    </>}>
      {!activeCompany && <Typography>Select a company in the sidebar</Typography>}
      {!!activeCompany && <>
        <SearchBox
          simple={true}
          onSearch={(s) => {
            setPage(0);
            onSearch(s);
          }}
        />
        <DataGrid
          action_count={2}
          actions={(params) => {
            return (<>
              {/* {checkAllowed(login, null, projectId?.toString() || '0', "ProjectSegments", 'u', true) && <StyledIconButton title="Edit" color="primary" path={`/segment/${projectId}/${params.row.id}`}>
                <EditIcon />
              </StyledIconButton>} */}
              {!params.row.autogenerated && <StyledIconButton title="Edit" color="primary" path={`/segment/${params.row.id}`}>
                <EditIcon />
              </StyledIconButton>}
              {!!removeLoader && <CircularProgress />}
              {/* {checkAllowed(login, null, projectId?.toString() || '0', "ProjectSegments", 'd', true) && !removeLoader && <StyledIconButton title="Destroy" destroyBtn color="primary" onClick={(e) => {
                onRemove(params.row.id);
              }}>
                <DeleteForeverIcon />
              </StyledIconButton>} */}
              {!removeLoader && <StyledIconButton title="Destroy" destroyBtn color="primary" onClick={(e) => {
                onRemove(params.row.id);
              }}>
                <DeleteForeverIcon />
              </StyledIconButton>}
            </>);
          }}
          getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
          objectCount={objectsCount}
          objects={(objects || []).map(u => ({
            ...u
          }))}
          columns={columns}
          loader={loader}
          onSortModelChange={(a, b) => {
            let a_0_field:string = a[0].field;
            setOrder([a_0_field, a[0].sort].join(' '));
          }}
          page={page}
          setPage={(p) => {setPage(p);}}
        />

        {!!serverErrorSnackOpen && <AlertSomethingWentWrong open={serverErrorSnackOpen} setOpen={(b) => {setServerErrorSnackOpen(b);}} />}
        {!!open && <Snackbar
        open={open}
          onClose={() => {setOpen(false);}}
          autoHideDuration={2000}
        >
          <MuiAlert elevation={6} variant="filled" severity="success">Copied!</MuiAlert>
        </Snackbar>}
      </>}
    </Page>
  );
}
